import { Button, Paper, Stack } from '@mui/material';

type ConfigSaverProps = {
    onSave?: () => void;
    onCancel?: () => void;
};

export const ConfigSaver = ({
    onCancel = () => undefined,
    onSave = () => undefined,
}: ConfigSaverProps): JSX.Element | null => {
    return (
        <Paper
            sx={{
                position: 'absolute',
                right: 48,
                top: 40,
                px: 2,
                py: 1,
                boxShadow:
                    '0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%)',
            }}
            component={Stack}
        >
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
            >
                <Button
                    variant="outlined"
                    size="small"
                    onClick={onCancel}
                    sx={{ mr: 2 }}
                >
                    Отмена
                </Button>
                <Button variant="contained" size="small" onClick={onSave}>
                    Сохранить изменения
                </Button>
            </Stack>
        </Paper>
    );
};
